<script setup lang="ts">
import ViewLayout from '@/views/layouts/ViewLayout.vue'
import type { TabsPaneContext } from 'element-plus'
import { computed } from 'vue'
import { RouterView, useRouter } from 'vue-router'

const router = useRouter()

const activeTab = computed(() => router.currentRoute.value.name?.toString())

const handleTabClick = (tab: TabsPaneContext) => {
  router.push({ name: tab.props.name!.toString() })
}
</script>

<template>
  <ViewLayout>
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="Uninvoiced" name="rc-billing-uninvoiced" />
      <el-tab-pane label="Invoiced" name="rc-billing-invoiced" />
    </el-tabs>
    <RouterView />
  </ViewLayout>
</template>
